import classNames from "classnames";
import _ from "lodash";
import { useFormContext } from "react-hook-form";
import { LTooltip } from "./LTooltip";

export const LSelect = ({ ...props }: SelectProps): JSX.Element => {
    const {
        register,
        formState: { errors }
    } = useFormContext();
    const error = _.get(errors, props.inputName);
    const hasError = error !== undefined && error !== null;
    const fieldError = error?.message?.toString() ?? "";
    const selectClassname = props.theme === "grey" ? "is-grey" : props.theme === "dark" ? "is-primary" : "";
    const classes = classNames(
        "select",
        "control",
        props.isFullWidth ? "is-fullwidth" : "",
        hasError ? "is-danger" : "",
        props.classes
    );

    const labelClasses = classNames("label", "is-small", props.theme === "dark" ? "has-text-white" : "", "is-flex");

    return (
        <div className={"field " + (props.isInline ? "is-inline-block" : "")}>
            <label className={labelClasses}>
                {props.label}
                {props.tooltip?.length && (
                    <div className="ml-3">
                        <LTooltip text={props.tooltip} direction="down" />
                    </div>
                )}
            </label>
            <div className={classes}>
                <select
                    className={selectClassname}
                    defaultValue={props.defaultValue}
                    value={props.value}
                    {...register(props.inputName, { onChange: props.onChange })}
                    disabled={props.disabled}
                >
                    {props.defaultOption && (
                        <option value={props.defaultOption.value}>{props.defaultOption.name}</option>
                    )}
                    {props.options.map((o) => (
                        <option value={o.value ?? o.name} key={`option-${o.name}`}>
                            {o.name}
                        </option>
                    ))}
                </select>
            </div>
            <p className={`help is-danger ${hasError ? "" : "is-hidden-custom"}`}>{fieldError || "*"}</p>
        </div>
    );
};

export interface SelectProps {
    options: SelectOption[];
    defaultOption?: SelectOption;
    defaultValue?: string;
    value?: string;
    label: string;
    isFullWidth?: boolean;
    inputName: string;
    /** HTML input `onChange` attribute */
    onChange?: React.ChangeEventHandler;
    /** Prefix for input name (for validation of nested objects) */
    inputNamePrefix?: string;
    isInline?: boolean;
    classes?: string;
    theme?: "dark" | "light" | "grey";
    disabled?: boolean;
    tooltip?: string;
}

export interface SelectOption {
    name: string;
    // selected?: boolean; //Going to use select list value instead
    value?: string; // if null, name will be value
}
